import React from "react";
import LandingPageSection from "../../Sections/LandingPageSection/Content";
const LandingPage = () => {
  return <LandingPageSection />;
};

export default LandingPage;
